import { useState } from "react";
import { TSummaryPeriod } from "../../../constants";
import { useAdminApiQueryWithParams } from "../../../hooks";
import { ITopUpsSummary, ITxOverview } from "../../../interfaces-and-types";
import { View } from "./View";
import { ISummarySectionProps, ISummarySectionViewProps } from "../Home";

export interface ITopUpsSummaryViewProps extends ISummarySectionViewProps<ITxOverview> {}

export const TopUpsSummary = ({
  activeCurrency,
  customChartPeriod,
}: ISummarySectionProps) => {
  const [summaryPeriod, setSummaryPeriod] = useState<TSummaryPeriod>("today");

  const {
    isLoading: isLoadingTopUpsSummary,
    // isSuccess: isSuccessTopUpsSummary,
    // isError: isErrorTopUpsSummary,
    data: topUpsSummary,
    refetch: refetchSummary,
  } = useAdminApiQueryWithParams<{ currency: string }, ITopUpsSummary>(
    [
      "getTopUpsSummary",
      {
        currency: activeCurrency!,
      },
    ],
    {
      enabled: !!activeCurrency,
    },
  );

  const {
    isLoading: isLoadingTopUpsOverviewByPeriod,
    // isSuccess: isSuccessTopUpsOverviewByPeriod,
    // isError: isErrorTopUpsOverviewByPeriod,
    data: topUpsOverviewByPeriod,
    refetch: refetchOverviewByPeriod,
  } = useAdminApiQueryWithParams<
    { currency: string; startDate: string; endDate: string },
    ITxOverview
  >(
    [
      "getTopUpsOverviewByPeriod",
      {
        currency: activeCurrency!,
        startDate: customChartPeriod.startDate,
        endDate: customChartPeriod.endDate,
      },
    ],
    {
      enabled:
        !!activeCurrency &&
        !!customChartPeriod.startDate &&
        !!customChartPeriod.endDate &&
        summaryPeriod === "custom",
    },
  );

  const refreshData =
    summaryPeriod === "custom" ? refetchOverviewByPeriod : refetchSummary;

  const summaryToDisplay =
    summaryPeriod === "today"
      ? topUpsSummary?.today
      : summaryPeriod === "past week"
        ? topUpsSummary?.past_week
        : summaryPeriod === "past month"
          ? topUpsSummary?.past_month
          : summaryPeriod === "custom"
            ? topUpsOverviewByPeriod
            : topUpsSummary?.all_time;

  const isLoadingSummary =
    summaryPeriod === "custom"
      ? isLoadingTopUpsOverviewByPeriod
      : isLoadingTopUpsSummary;

  return (
    <View
      activeCurrency={activeCurrency}
      isLoadingSummary={isLoadingSummary}
      summaryToDisplay={summaryToDisplay || null}
      summaryPeriod={summaryPeriod}
      setSummaryPeriod={setSummaryPeriod}
      refreshData={refreshData}
    />
  );
};
